import Button from 'components/Button'
import HelpIcon from 'components/layout/topnav/HelpIcon'
import { S } from 'components/layout/topnav/TopNav'
import UserInfo from 'components/layout/topnav/UserInfo'
import { MOBILE_BREAKPOINT } from 'constants/layout'
import { currentUserSelector } from 'features/auth/authSlice'
import CreateEvent from 'features/events/CreateEvent'
import { addModal } from 'features/modals/modalSlice'
import { OrganizationFragment } from 'generated/graphql'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { _ } from 'utils'

interface Props {
    logo: string
    screenWidth?: number
    organization: OrganizationFragment
}

const TopNav = ({ logo, screenWidth, organization }: Props) => {
    const dispatch = useDispatch()
    const user = useSelector(currentUserSelector)

    const showCreateEventModal = () => {
        dispatch(
            addModal({
                Component: ({ close }: { close: () => void }) => (
                    <CreateEvent
                        close={close}
                        organizations={[organization]}
                    />
                ),
                header: ' ',
            })
        )
    }

    if (screenWidth < MOBILE_BREAKPOINT) {
        return (
            <S.NavBar>
                <S.LogoWrapper screenWidth={screenWidth}>
                    <S.NavLogo src={logo} />
                </S.LogoWrapper>
            </S.NavBar>
        )
    }

    return (
        <S.NavBar>
            <S.LogoWrapper screenWidth={screenWidth}>
                <S.NavLogo src={logo} />
            </S.LogoWrapper>
            {organization && (
                <>
                    <S.Divider />
                    <S.EventInfoWrapper>
                        <S.EventInfo>{organization.name}</S.EventInfo>
                        <S.EventActions>
                            {organization.membershipActivatedAt && (
                                <Button
                                    variant="primary"
                                    onClick={showCreateEventModal}
                                    className="text-white"
                                    icon="plusBox"
                                >
                                    {_('top_navigation.create_event')}
                                </Button>
                            )}
                        </S.EventActions>
                    </S.EventInfoWrapper>
                    <S.Divider />
                </>
            )}
            <div className="flex-align-center">
                <UserInfo user={user} />
                <HelpIcon />
            </div>
        </S.NavBar>
    )
}

export default TopNav
